import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useScrollNavigation() {
  const navigate = useNavigate();

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const navigateAndScroll = useCallback((path: string) => {
    navigate(path);
    scrollToTop();
  }, [navigate, scrollToTop]);

  return { navigateAndScroll, scrollToTop };
}